module.exports = __webpack_public_path__ + "54b840e458d480c220b105c71c5f564a.png";